import { defineStore } from 'pinia';
import axiosInstance from '@/services/axios'; // Import the instance

export const useSettingsStore = defineStore('settings', {
    state: () => ({
        settings: {}, // Global settings
    }),
    actions: {
        async fetchSettings() {
            try {
                const response = await axiosInstance.get('/settings');
                this.settings = response.data;
            } catch (error) {
                console.error('Error fetching settings:', error);
            }
        },
    },
    getters: {
        getCurrency: (state) => state.settings.currency || 'USD',
        getWebName: (state) => state.settings.web_name || 'My Website',
        getWebLogo: (state) => state.settings.web_logo || '/default-logo.png',
    },
});
